import { fixFormDataAsObject } from './generalTS';
import { ErrorReporter } from './ErrorReporter';
export class SelectizeEx {
    static createSelectizeOptions(elementId, url, selectizeOptions) {
        if (selectizeOptions.render && selectizeOptions.render.option)
            eval("selectizeOptions.render.option = " + selectizeOptions.render.option);
        if (selectizeOptions.render && selectizeOptions.render.optgroup_header)
            eval("selectizeOptions.render.optgroup_header = " + selectizeOptions.render.optgroup_header);
        if (selectizeOptions.onInitialize)
            eval("selectizeOptions.onInitialize = " + selectizeOptions.onInitialize);
        if (selectizeOptions.onChange)
            eval("selectizeOptions.onChange = " + selectizeOptions.onChange);
        if (selectizeOptions.createAddObject)
            eval("selectizeOptions.createAddObject = " + selectizeOptions.createAddObject);
        if (selectizeOptions.createFunc)
            eval("selectizeOptions.create = " + selectizeOptions.createFunc);
        if (url) {
            selectizeOptions.load = function (query, callback) {
                let data = $(".selectize-data").serializeArray();
                data.push({
                    name: "Query",
                    value: query
                });
                if (GeolocationEx.geoCoords) {
                    data.push({
                        name: "Latitude",
                        value: GeolocationEx.geoCoords.latitude.toString()
                    });
                    data.push({
                        name: "Longitude",
                        value: GeolocationEx.geoCoords.longitude.toString()
                    });
                }
                let dataAsRecord = fixFormDataAsObject(data);
                let tryCount = 1;
                let retryLimit = 3;
                AjaxEx.ajax({
                    url: url,
                    method: "POST",
                    contentType: 'application/json',
                    data: JSON.stringify(dataAsRecord),
                    dataType: "json",
                    error: function (res) {
                        if (url.indexOf("api/PeL/aircraft/search") > 0 || url.indexOf("api/PeL/airports/search") > 0) {
                            dataAsRecord["tryCount"] = tryCount.toString();
                            ErrorReporter.ReportAjaxError(url, dataAsRecord, res);
                            if (tryCount <= retryLimit) {
                                tryCount++;
                                AjaxEx.ajax(this, true);
                                return;
                            }
                        }
                        else {
                            ErrorReporter.ReportAjaxError(url, dataAsRecord, res);
                        }
                        callback();
                    },
                    success: function (res) {
                        if (query && selectizeOptions.createAddObject) {
                            let addObject = selectizeOptions.createAddObject(query);
                            addObject.CssClass = 'add';
                            addObject.Group = 'Add';
                            res.unshift(addObject);
                            SelectizeEx.getSelectizeObjectFor(elementId)?.clearOptions();
                        }
                        callback(res);
                    }
                }, true);
            };
        }
        let selectizeObject = $('#' + elementId).selectize(selectizeOptions)[0].selectize;
        SelectizeEx.selectizeObjects.set(elementId.toLowerCase(), selectizeObject);
        $.validator.defaults.ignore += `:not(#${elementId})`;
        selectizeObject.on('change', function () { $(`#${elementId}`).valid(); });
        return selectizeObject;
    }
    ;
    static getSelectizeObjectFor(elementId) {
        return SelectizeEx.selectizeObjects.get(elementId.toLowerCase());
    }
    static clearOptions() {
        SelectizeEx.selectizeObjects.forEach((value, key, map) => {
            value.clearOptions();
        });
    }
}
SelectizeEx.selectizeObjects = new Map();
class ReducedHeightSelectize {
    static adjustPadding() {
        $('.selectize-control.reduced-height-selectize > div.selectize-input')
            .each(function () {
            let jQthis = $(this);
            let height = jQthis.outerHeight(false);
            let innerDivItem = jQthis.children('div.item');
            let innerHeight = null;
            if (innerDivItem.length) {
                innerHeight = $(jQthis.children('div.item')[0]).outerHeight(true);
            }
            else {
                innerHeight = $(jQthis.children('input')[0]).outerHeight(true);
            }
            if (height && innerHeight) {
                let padding = (height - innerHeight) / 2;
                jQthis.css('padding-top', padding + 'px');
            }
        });
    }
    static registerAdjustPadding() {
        ReducedHeightSelectize.adjustPadding();
        if (!ReducedHeightSelectize.registeredAdjustPadding) {
            $(window).resize(ReducedHeightSelectize.adjustPadding);
            ReducedHeightSelectize.registeredAdjustPadding = true;
        }
    }
    ;
}
ReducedHeightSelectize.registeredAdjustPadding = false;
window.SelectizeEx = SelectizeEx;
window.ReducedHeightSelectize = ReducedHeightSelectize;
$(document).ready(function () {
    $(".selectize-data").change(function () {
        SelectizeEx.clearOptions();
    });
    window.selectizeExGetSelectizeObjectFor = SelectizeEx.getSelectizeObjectFor;
});
